module.exports = __webpack_public_path__ + "images/icon_bet_plus_c6c0fc1d9213c203f8287f9a19bceed8.svg";